module.exports = __webpack_public_path__ + "static/media/barandal-led.aa9856ac.jpg";